import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import supabase from 'modules/core/supabase/supabase';
import { Background, backgroundColors } from 'shared/constants/backgrounds';
import type { LogoBackgroundDto } from 'modules/core/domain/interfaces/supabase/organizer-logo-background/response-dto';

export interface UpdateLogoBackgroundParams {
  bgColor?: Background;
  tournamentId?: number;
}

/**
 * Хук для обновления фона логотипа организатора с немедленным обновлением кэша useFetchLogoBackground.
 * Позволяет запускать операцию параллельно с апсертом организатора.
 */
export function useUpdateLogoBackground() {
  const queryClient = useQueryClient();

  const updateLogoBackground = useCallback(
    async (params: UpdateLogoBackgroundParams) => {
      const { bgColor, tournamentId } = params;

      // Если цвет не задан — ничего не делаем
      if (!bgColor) return false;

      // Находим тип фона по значению цвета
      let backgroundType: number | undefined = undefined;
      for (const [key, value] of Object.entries(backgroundColors)) {
        if (value.value === bgColor.value) {
          const parsed = parseInt(key, 10);
          if (!Number.isNaN(parsed)) backgroundType = parsed;
          break;
        }
      }

      if (backgroundType === undefined || Number.isNaN(backgroundType)) {
        return false;
      }

      if (!tournamentId) return false;

      const result = await supabase.organizerLogoBacking.update({ tournamentId: tournamentId, type: backgroundType });

      // Обновляем кэш конкретного турнира без инвалидации
      queryClient.setQueryData<LogoBackgroundDto | null>(['logo-backgrounds', tournamentId], result);

      return result;
    },
    [queryClient],
  );

  return { updateLogoBackground };
}
